
import React, { Component } from "react";
import Moment from 'react-moment';
import moment from "moment"
import {Button,Panel,Label,Glyphicon } from "react-bootstrap";


export const LogicDisplay = (props)=>{
  let d=props.data
  let t=d.time
  if(t==0){
    t="---"
  }
  else{
    t=new Date(d.time*1000-2000)
  }
  let stateClass="eventFalse"
  let state=(<span><Panel.Toggle>{d.name}:&nbsp;</Panel.Toggle><Label>---</Label></span>)


  let enabled=""

  if(d.enabled==false){

    enabled=(<Label className={"level3"}>Disabled!</Label>)
  }

//  alert(d.state)
  if(d.state==true){
    stateClass="eventTrue"
    state=(<span><b><Panel.Toggle>{d.name}:&nbsp;</Panel.Toggle><Label className={"level"+d.level}>True</Label>&nbsp;{enabled}</b></span>)
  }
  if(d.state==false){
    state=(<span><Panel.Toggle>{d.name}:&nbsp;</Panel.Toggle><Label>False</Label>&nbsp;{enabled}</span>)
  }

  let toggleButton=(<Button className="pull-right "  bsSize="xsmall" onClick={()=>props.callback(props,"enable")}>Enable</Button>)

  if(d.enabled==true){
    toggleButton=(<Button className="pull-right "  bsSize="xsmall" onClick={()=>props.callback(props,"disable")}>Disable</Button>)
  }else{
    toggleButton=(<Button className="pull-right "  bsSize="xsmall" onClick={()=>props.callback(props,"enable")}>Enable</Button>)
  }

  return (

  <Panel bsSize="small" className={stateClass+" eventAlert event"+d.level+" Enabled"+d.enabled}>
          <Panel.Heading>
            <Panel.Title>
{state}


     <Button className="pull-right"  bsSize="xsmall" onClick={()=>props.callback(props,"delete")}>  <Glyphicon glyph="trash" /> Delete</Button>
                      <Button className="pull-right "  bsSize="xsmall" onClick={()=>props.callback(props,"edit")}><Glyphicon glyph="pencil" /> Edit</Button>
                      {toggleButton}
                      <span className="pull-right " >&nbsp;<Moment fromNow interval={1000}>{t}</Moment>&nbsp;</span>
            </Panel.Title>
          </Panel.Heading>
  <Panel.Body collapsible>
    <p><Button onClick={()=>props.callback(props,"edit")}><Glyphicon glyph="pencil" /> Edit</Button></p>
  </Panel.Body>
</Panel>
          )
}



// WEBPACK FOOTER //
// ./src/programmerComponents/LogicDisplay.js